<div class="decline-mapping-grid-cells" *ngIf="row">
  <button type="button" class="dm-del-btn" (click)="onDelete($event)" title="Delete category">×</button>
</div>
